import Vue from 'vue'

export default {
  getAccounts ({ commit }) {
    return Vue.axios.get(`/accounts`)
    .then(({ data }) => commit('ADD_ACCOUNTS', data))
  },
  getRoles ({ commit }) {
    return Vue.axios.get(`/accounts/roles`)
    .then(({ data }) => commit('ADD_ROLES', data))
  },
  addAccount ({ commit }, account) {
    return Vue.axios.post(`/accounts`, { account })
    .then(({ data }) => commit('ADD_NEW_ACCOUNT', data))
  },
  addAccountSchema ({ commit }, account) {
    commit('ADD_ACCOUNT_SCHEMA', account)
  },
  deleteAccount ({ commit }, id) {
    return Vue.axios.delete(`/accounts/${id}`)
    .then(() => commit('DELETE_ACCOUNT', id))
  },
  updateAccount ({ commit }, account) {
    return Vue.axios.put(`/accounts`, { account })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/accounts.js